//网络请求接口
import axios from 'axios';
import Vue from 'vue'
import utils from './utils.js';
import interfaceToast from '@/i18n/interfaceToast-zh-CN';

export let request = {
  instance: undefined,
  instanceFile: undefined,
  url: {
    login: {
      login: "/auth/adminLogin",
      getMenuRounters: "/system/menu/getRouters",
      getRoutersMenu: "/system/menu/getRoutersMenu",
      snlLogin: "/auth/sll/login",
      updatePwd: "/system/user/profile/updatePwd"
    },
    menu: {
      getMenuList: "/admin/menu/list",
      editMenu: "/admin/menu",
      addMenu: "/admin/menu",
      deleteMenu: "/admin/menu/delete"
    },
    role: {
      getList: "/admin/role/list",
      add: "/admin/role/add",
      edit: "/admin/role/update",
      delete: "/admin/role/delete",
      getRoleMenuTreeSelect: "/admin/menu/roleMenuTreeselect/"
    },
    file: {
      uploadFile: "/file/upload",
      uploadCourseTemp: "/file/uploadCourseTemp",
      uploadCourse: "/file/uploadCourse",
      checkChunkStatus: "/file/checkChunkStatus",
      uploadOfficeToPdf: "/file/uploadOfficeToPdf"
    },
    scaleTemplate: {
      getScaleListByPage: "/admin/template/scale/page",
      deleteById: "/admin/template/scale/deleteById",
      getScaleInfo: "/admin/template/scale/",
      updateQuestionByScale: "/admin/template/question/updateQuestionByScale",
      editScale: "/admin/template/scale/edit",
      addScale: "/admin/template/scale/add",
      getScaleList: "/admin/template/scale/list",
      editScaleReportRule: "/admin/template/scale/report/rule/edit",
      editWarningReportRule: "/admin/template/scale/warning/rule/edit",
      jumpRuleAdd: "/admin/template/jump/rule/add",
      getJumpRule: "/admin/template/jump/rule/info/",
      orderUp: "/admin/template/scale/orderUp/",
      summaryRuleAdd: "/admin/template/report/summary/rule/add",
      getSummaryRuleInfo: "/admin/template/report/summary/rule/info/",
      getScaleRuleList: "/admin/template/scale/getRuleInfo/",
      getScaleScoreRuleList: "/admin/template/scale/score/rule/list",
      addScaleScoreRule: "/admin/template/scale/score/rule/add",
      deleteScaleScoreRule: "/admin/template/scale/score/rule/deleteById",
      importScaleScoreRule: "/admin/template/scale/score/rule/import",
      importScale: "/admin/template/scale/import",
      getScaleSecondLabel: "/admin/template/scale/secondLabel/",
      copyXyScale: "/admin/template/scale/copy/"
    },
    scaleType: {
      getScaleCategory: "/admin/scale/category/page",
      editScaleCategory: "/admin/scale/category",
      addScaleCategory: "/admin/scale/category",
      deleteScaleCategory: "/admin/scale/category/delete"
    },
    personnel: {
      getUserListByPage: "/system/userAdmin/page",
      changeStatus: "/system/userAdmin/changeStatus",
      deleteUser: "/system/userAdmin/",
      resetPwd: "/system/userAdmin/resetPwd",
      editUserInfo: "/system/userAdmin",
      addUser: "/system/userAdmin",
      getUserInfo: "/system/userAdmin/"
    },
    orderManager: {
      getOrderListByPage: "/admin/order/page",
      getOrderInfo: "/admin/order/info/",
      update: "/admin/order/update",
      add: "/admin/order/add",
      process: "/admin/order/process",
      delete: "/admin/order/delete"
    },
    tenant: {
      getTenantListByPage: "/admin/tenant/page",
      add: "/admin/tenant/init",
      update: "/admin/tenant/update",
      getTenantInfo: "/admin/tenant/info/"
    },
    address: {
      getAreaList: "/admin/area/child/"
    },
    log: {
      getLogList: '/system/logininfor/list',
      getlogOperationList: '/system/operlog/list'
    },
    device: {
      getDeviceListByPage: "/system/xyDeviceInfo/list",
      getDeviceOpsRecordPage: '/system/xyDeviceOpsRecord/page',
      deleteDevice: "/system/xyDeviceInfo/delete/",
      getDeviceInfoById: "/system/xyDeviceInfo/getOne/",
      addDevice: "/system/xyDeviceInfo/add",
      editDevice: "/system/xyDeviceInfo/edit",
      activeList: "/system/xyDeviceInfo/activeList",
      activationDevice: "/system/xyDeviceInfo/activeEdit",
      importData: "/system/xyDeviceInfo/importData"
    },
    dict: {
      getDictList: "/admin/dict/type/list",
      getDictTypeList: "/admin/dict/data/list",
      addDict: "/admin/dict/type",
      deleteDict: '/admin/dict/type/',
      addDictType: '/admin/dict/data',
      deleteDictType: '/admin/dict/data/',
    },
    factor: {
      getFactorList: "/admin/label/page",
      addFactor: "/admin/label/save",
      editFactor: "/admin/label/updateById"
    },
    course: {
      getCourseCategory: "/admin/courseCategory/page",
      deleteCourseCategory: "/admin/courseCategory/delete",
      editCourseCategory: "/admin/courseCategory",
      addCourseCategory: "/admin/courseCategory",
      addCourse: "/admin/course/add",
      editCourse: "/admin/course/update",
      getCourseDetails: "/admin/course/info/",
      getCourseList: "/admin/course/admin/page",
      courseBuyList: "/admin/course/buy/record/page",
      deleteCourse: "/admin/course/delete"
    },
    notification: {
      add: "/admin/msgNotification",
      getNotificationManagerListByPage: "/admin/msgNotification/page",
      edit: "/admin/msgNotification",
      getNotificationDetailsById: "/admin/msgNotification/",
      deleteNotificationById: "/admin/msgNotification/",
      recall: "/admin/msgNotification/{id}/recall",
      send: "/admin/msgNotification/{id}/sent"
    },
    psychologicalHotline: {
      getPsychologicalHotlineList: '/admin/hotline/page',
      addPsychologicalHotline: '/admin/hotline',
      editPsychologicalHotline: '/admin/hotline',
      getPsychologicalHotline: '/admin/hotline/',
      deletePsychologicalHotline: '/admin/hotline/',
    },
    customer: {
      getCustomerList: "/admin/customerMap/flagList",
      delete: "/admin/customerMap/flag/",
      add: "/admin/customerMap/flag",
      update: "/admin/customerMap/flag",
      getDetailsById: "/admin/customerMap/flag/",
      getAreaList: '/admin/customerMap/areaList',
      addArea: "/admin/customerMap/area",
      editArea: "/admin/customerMap/area"
    },
    newsAndInformation: {
      getListByPage: "/admin/xyOfficialNews/page",
      delete: "/admin/xyOfficialNews/",
      add: "/admin/xyOfficialNews",
      edit: "/admin/xyOfficialNews",
      getDetailsById: "/admin/xyOfficialNews/"
    }
  },
  courseUrlList: [],
  create(instance) {
    let that = this;
    // 添加请求拦截器
    instance.interceptors.request.use(function (config) {
      // 添加语言
      config.headers["Global-Language"] = localStorage.getItem("language");
      if (utils.isLogin()) {
        var userInfo = utils.getUserInfo();
        if (!config.headers.tenantId) {
          config.headers.tenantId = userInfo.tenantId;
        }
        config.headers.Authorization = "Bearer " + userInfo.token;
      } else {
        if (!config.headers.tenantId) {
          config.headers.tenantId = "886";
        }
      }
      return config;
    }, function (error) {
      return Promise.reject(error);
    });
    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      return Promise.reject(error);
    });
    window.postFileUtils = function (file) {
      return new Promise((resolve, reject) => {
        let formdata = new FormData();
        formdata.append("file", file);
        let params = {
          url: that.url.file.uploadFile,
          file: formdata,
        };
        that.postFile(params, (type, response) => {
          if (type == 0) {
            resolve(response.data.url);
          } else {
            reject();
          }
        });
      })
      
    }
  },
  //初始化
  init: function () {
    for (let i in this.url.course) {
      this.courseUrlList.push(this.url.course[i])
    }
    this.instance = axios.create({
      baseURL: window.baseURL,
      timeout: 300000,
    });
    this.create(this.instance);
    this.instanceFile = axios.create({
      baseURL: window.baseURL,
      timeout: 600000,
    });
    this.create(this.instanceFile);
  },
  get: function (params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    if (this.courseUrlList.some(v => v == params.url)) {
      headers['tenantId'] = '887'
    }

    this.instance.get(params.url, {
      params: params.data,
      headers: headers
    }).then(function (response) {
      if (cb) {
        isCorrect(response.data, cb, params);
      }
    }).catch(function (error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  delete: function (params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    if (this.courseUrlList.some(v => v == params.url)) {
      headers['tenantId'] = '887'
    }
    this.instance.delete(params.url, {
      params: params.data,
      headers: headers
    }).then(function (response) {
      if (cb) {
        isCorrect(response.data, cb, params);
      }
    }).catch(function (error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  initPost: function (obj) {
    var query = '',
      name, value, fullSubName, subName, subValue, innerObj, i;
    for (name in obj) {
      value = obj[name];
      if (value instanceof Array) {
        for (i = 0; i < value.length; ++i) {
          subValue = value[i];
          fullSubName = name + '[' + i + ']';
          innerObj = {};
          innerObj[fullSubName] = subValue;
          query += this.initPost(innerObj) + '&';
        }
      } else if (value instanceof Object) {
        for (subName in value) {
          subValue = value[subName];
          fullSubName = name + '[' + subName + ']';
          innerObj = {};
          innerObj[fullSubName] = subValue;
          query += this.initPost(innerObj) + '&';
        }
      } else if (value !== undefined && value !== null)
        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
    }
    return query.length ? query.substr(0, query.length - 1) : query;
  },
  /**
   * post请求
   * @param {Object} params 参数
   * @param {Object} cb 回调函数
   */
  post: function (params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    if (this.courseUrlList.some(v => v == params.url)) {
      headers['tenantId'] = '887'
    }
    this.instance.post(params.url, params.data, {
      headers: headers,
      responseType: params.responseType ? params.responseType : 'json'
    }).then(function (response) {
      if (cb) {
        if (params.responseType == "blob") {
          cb(0, response.data);
        } else if (params.responseType == "stream") {
          cb(0, response.data);
        } else {
          isCorrect(response.data, cb, params);
        }
      }
    }).catch(function (error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  /**
   * put请求
   * @param {Object} params 参数
   * @param {Object} cb 回调函数
   */
  put: function (params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/json;charset=UTF-8";
    }
    if (this.courseUrlList.some(v => v == params.url)) {
      headers['tenantId'] = '887'
    }
    this.instance.put(params.url, params.data, {
      headers: headers,
      responseType: params.responseType ? params.responseType : 'json'
    }).then(function (response) {
      if (cb) {
        if (params.responseType == "blob") {
          cb(0, response.data);
        } else {
          isCorrect(response.data, cb, params);
        }
      }
    }).catch(function (error) {
      if (error.response && error.response.data) {
        errorHandle(error.response.data, cb, params);
      } else {
        errorHandle(error, cb, params);
      }
    });
  },
  postFile: function (params, cb, baseUrl) {
    var config = {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    }
    if (this.courseUrlList.some(v => v == params.url)) {
      config.headers['tenantId'] = '887'
    }
    this.instanceFile.post(params.url, params.file, config)
      .then(function (response) {
        if (cb) {
          isCorrect(response.data, cb, params)
        }
      }).catch(function (error) {
        if (error.response && error.response.data) {
          errorHandle(error.response.data, cb, params);
        } else {
          errorHandle(error, cb, params);
        }
      });
  },
  /**
   * post请求
   * @param {Object} params 参数
   * @param {Object} cb 回调函数
   */
  postForm: function (params, cb) {
    var headers = params.headers;
    if (!headers) {
      headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      };
    } else {
      headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    if (this.courseUrlList.some(v => v == params.url)) {
      headers['tenantId'] = '887'
    }
    var config = {
      headers: headers,
    }
    this.instance.post(params.url, this.initPost(params.data), config)
      .then(function (response) {
        if (cb) {
          isCorrect(response.data, cb, params)
        }
      }).catch(function (error) {
        if (params.doNotProcessResults) return;
        if (error.response && error.response.data) {
          errorHandle(error.response.data, cb, params);
        } else {
          errorHandle(error, cb, params);
        }
      });
  }
}

/**
 * 判断接口是否访问成功
 */
let isCorrect = function (result, cb, params) {
  if (result.code && result.code == 200) {
    cb(0, result)
  } else {
    cb(1, result)
    errorHandle(result, cb, params);
  }
};
let errorHandle = function (result, cb, params) {
  console.log(result)
  cb(1, result);
  if (result && result.code) {
    if (result.code == 401) { //token过期
      const expirationTime = sessionStorage.getItem('expirationTime');
      const currentTime = new Date().getTime();
      if (currentTime - expirationTime > 5000) {
        utils.exitLogin(Vue.prototype.bus.$router, true);
        sessionStorage.setItem('expirationTime', currentTime);
      }
    } else if (interfaceToast[result.code]) {
      showErrorToast(Vue.prototype.bus.$t("interfaceToast." + result.code));
    } else if (result.msg) {
      showErrorToast(result.msg);
    } else {
      var text = Vue.prototype.bus.$t('interfaceToast.interfaceError');
      showErrorToast(text.replace('&&', result.code));
    }
  } else {
    showErrorToast(Vue.prototype.bus.$t('interfaceToast.networkError'));
  }
}
var showErrorToast = function (message) {
  if (message) {
    Vue.prototype.$toast.showToast(message, "error");
  }
};


// WEBPACK FOOTER //
// ./src/utils/httpRequest.js